export const CoresEnum = {
  Claro: 'Claro',
  Medio: 'Medio',
  Escuro: 'Escuro',
}
export type TCores = keyof typeof CoresEnum

export const DetalhesCores = {
  Claro: {
    label: 'claro',
    verde: 'bg-green-100',
    laranja: 'bg-orange-100',
    amarelo: 'bg-yellow-100',
    vermelho: 'bg-red-100',
    shade: '100',
  },
  Medio: {
    label: 'médio',
    verde: 'bg-green-200',
    laranja: 'bg-orange-200',
    amarelo: 'bg-yellow-200',
    vermelho: 'bg-red-200',
    shade: '200',
  },
  Escuro: {
    label: 'escuro',
    verde: 'bg-green-300',
    laranja: 'bg-orange-300',
    amarelo: 'bg-yellow-300',
    vermelho: 'bg-red-300',
    shade: '300',
  },
}

export const CoresPorStatus = {
  Disponivel: {
    Claro: {
      fill: '#DCFCE7',
      text: '#064e3b',
    },
    Medio: {
      fill: '#B9F8CF',
      text: '#064e3b',
    },
    Escuro: {
      fill: '#7BF1A8',
      text: '#064e3b',
    },
  },
  Indisponivel: {
    Claro: {
      fill: '#FFE2E2',
      text: '#7f1d1d',
    },
    Medio: {
      fill: '#FFC9C9',
      text: '#7f1d1d',
    },
    Escuro: {
      fill: '#FFA2A2',
      text: '#7f1d1d',
    },
  },
  ReservadoPorProposta: {
    Claro: {
      fill: '#FFEDD4',
      text: '#9a3412',
    },
    Medio: {
      fill: '#FFD7A8',
      text: '#9a3412',
    },
    Escuro: {
      fill: '#FFB86A',
      text: '#9a3412',
    },
  },
  ReservadoPeloVendedor: {
    Claro: {
      fill: '#FEF9C2',
      text: '#92400e',
    },
    Medio: {
      fill: '#FFF085',
      text: '#92400e',
    },
    Escuro: {
      fill: '#FFDF20',
      text: '#92400e',
    },
  },
}
